var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOmwLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 36,
    viewBox: "0 0 201 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5765 29.111V18.0183C47.5765 15.5158 46.2799 13.9663 44.1664 13.9663C42.0529 13.9663 40.6072 15.5547 40.6072 18.0183V29.111H34.15V12.0408C34.15 10.6923 33.0025 9.44752 32.043 8.61768L37.4823 8.68898C40.1793 8.68898 40.5877 10.4394 40.5877 11.5157L41.5148 11.6842C41.9386 10.854 42.5783 10.1533 43.3666 9.65584C44.155 9.15841 45.0628 8.88265 45.9946 8.85755C46.4031 8.82513 46.7985 8.80569 47.1875 8.80569C51.4664 8.80569 54.0272 11.3536 54.0272 15.6454V29.0851L47.5765 29.111Z",
    fill: "#EFF2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5773 29.1107V12.1378L72.1022 23.8075L64.6726 12.235V29.0913H58.2349V2.43896H65.4571L72.1865 13.5641L78.916 2.43896H86.1317V29.1107H79.5773Z",
    fill: "#EFF2FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2518 35.5422C94.1031 35.5433 91.989 35.0014 90.1058 33.9668L92.0507 29.5777C92.965 30.1139 93.9892 30.4354 95.0459 30.5178C95.4563 30.5434 95.8661 30.4583 96.2323 30.2714C96.5986 30.082 96.9092 29.8005 97.1335 29.4545L97.2696 29.2471L89.1917 8.71484H95.8693L100.407 22.6796L104.686 8.75374H111.228L103.837 28.9424C101.983 33.8631 100.077 35.5422 96.2518 35.5422Z",
    fill: "#EFF2FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M138.807 29.3123L133.011 12.456L127.267 29.3123H121.38L112.628 2.43949H119.584L124.628 19.5097L130.21 2.36816H136.045L141.62 19.5097L146.677 2.43949H153.439L144.68 29.3123H138.807Z",
    fill: "#EFF2FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M185.511 35.5422C183.362 35.5424 181.248 35.0006 179.365 33.9668L181.271 29.5907C182.186 30.131 183.213 30.4547 184.273 30.5372C184.681 30.5636 185.089 30.4785 185.453 30.2909C185.82 30.1033 186.131 29.8214 186.354 29.474L186.503 29.2665L178.444 8.71484H185.141L189.68 22.6407L193.958 8.71484H200.5L193.103 28.897C191.242 33.8631 189.336 35.5422 185.511 35.5422Z",
    fill: "#EFF2FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M161.919 29.9005C156.207 29.9005 151.89 25.2002 151.89 19.0282C151.89 12.8562 156.207 8.10405 161.919 8.10405C163.131 8.07067 164.338 8.27876 165.468 8.71618C166.599 9.1536 167.632 9.81162 168.506 10.6519L169.29 11.4364V8.73292H175.65V29.2651H169.375V26.8469H168.726L168.506 26.996C167.67 27.9211 166.65 28.6609 165.511 29.1679C164.38 29.6665 163.155 29.9163 161.919 29.9005ZM164.117 13.4851C163.401 13.4699 162.69 13.6046 162.029 13.8806C161.361 14.154 160.756 14.5623 160.253 15.08C159.746 15.5993 159.351 16.2171 159.092 16.8952C158.827 17.5741 158.701 18.2996 158.723 19.0282C158.714 20.482 159.28 21.8804 160.298 22.9181C160.793 23.4249 161.385 23.8275 162.038 24.1024C162.691 24.3773 163.392 24.519 164.101 24.519C164.809 24.519 165.51 24.3773 166.163 24.1024C166.816 23.8275 167.408 23.4249 167.903 22.9181C168.921 21.8804 169.488 20.482 169.478 19.0282C169.501 18.3022 169.378 17.579 169.115 16.9017C168.859 16.2239 168.466 15.606 167.961 15.0864C167.464 14.5708 166.866 14.1627 166.205 13.8873C165.544 13.6119 164.833 13.475 164.117 13.4851Z",
    fill: "#EFF2FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_789_7305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1762 29.6991L14.8027 29.6851C12.151 29.5878 9.57383 28.7816 7.33935 27.3505C5.10487 25.9194 3.29474 23.9157 2.09731 21.5478C0.899875 19.1799 0.358892 16.5345 0.530656 13.8866C0.702419 11.2388 1.58065 8.68537 3.07396 6.49203L3.28471 6.18213L7.08428 13.6957C6.85097 15.3798 7.13704 17.0951 7.90428 18.6123C8.67153 20.1296 9.88343 21.3767 11.3782 22.187L15.1762 29.6991Z",
    fill: "url(#paint0_linear_789_7305)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1996 14.8481C30.2061 18.3022 29.0055 21.65 26.8053 24.3127C24.6051 26.9755 21.5436 28.7857 18.1501 29.4306L15.0989 23.1923H15.35C16.7767 23.1927 18.1797 22.8273 19.4249 22.131C20.6702 21.4347 21.7161 20.4307 22.4628 19.2151C23.2095 17.9994 23.6319 16.6126 23.6899 15.1871C23.7479 13.7616 23.4393 12.3451 22.7938 11.0728C22.1483 9.80052 21.1873 8.715 20.0027 7.91992C18.8181 7.12484 17.4494 6.64676 16.0273 6.53135C14.6053 6.41594 13.1774 6.66705 11.8801 7.2607C10.5827 7.85435 9.45929 8.7707 8.61704 9.92223L5.56592 3.67769C8.26594 1.29347 11.7479 -0.0156501 15.35 -0.000852472C19.2869 0.0036587 23.0614 1.56955 25.8453 4.3533C28.6291 7.13705 30.1951 10.9113 30.1996 14.8481Z",
    fill: "url(#paint1_linear_789_7305)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_789_7305",
    x1: -0.142262,
    y1: -2.30482,
    x2: 15.9217,
    y2: 43.0197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.164203,
    stopColor: "#8594CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.431264,
    stopColor: "#DDE4FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550769,
    stopColor: "#DDE4FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.700224,
    stopColor: "#8594CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_789_7305",
    x1: 21.0058,
    y1: 0.887215,
    x2: 26.683,
    y2: 27.9926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A63FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.165732,
    stopColor: "#01CFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354699,
    stopColor: "#0087FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.540421,
    stopColor: "#0069FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698073,
    stopColor: "#01CFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885485,
    stopColor: "#0A84FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0467F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_789_7305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.6992,
    height: 29.6995,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmwLogo);
export default __webpack_public_path__ + "static/media/omwLogo.0833b984092d0433bee0f51cd4590099.svg";
export { ForwardRef as ReactComponent };